module.exports = __webpack_public_path__ + "img/copy.221fed49.svg";